<template>
  <div :class="['toastification', variant]" role="status" aria-live="polite">
    <div class="toast__container">
      <div class="col-icon">
        <component :is="iconComponent" class="toast__icon" />
      </div>

      <div class="toast__content">
        <div class="toast__text-area">
          <span
            v-if="title"
            class="toast__title"
          >
            {{ title }}
          </span>

          <span
            v-if="text"
            class="toast__text"
          >
            {{ text }}
          </span>
        </div>
      </div>

      <div v-if="!hideClose" class="toast__close-button-c">
        <IconClose @click="$emit('close-toast')" />
      </div>
    </div>
  </div>
</template>

<script>
  import IconSuccess from '@/assets/icons/check-circle-icon.svg';
  import IconError from '@/assets/icons/cancel-circle-icon.svg';
  import IconInfo from '@/assets/icons/info-circle-icon.svg';
  import IconAlert from '@/assets/icons/alert-circle-icon.svg';
  import IconClose from '@/assets/icons/close-toast.svg';
  import IconAlertOutline from '@/assets/icons/alert-toastification-icon.svg';

  export default {
    components: {
      IconSuccess,
      IconError,
      IconInfo,
      IconAlert,
      IconClose,
      IconAlertOutline
    },
    props: {
      variant: {
        type: String,
        default: 'primary'
      },
      title: {
        type: String,
        default: null
      },
      text: {
        type: String,
        default: null
      },
      hideClose: {
        type: Boolean,
        default: false
      },
      icon: {
        type: String,
        default: null
      }
    },
    computed: {
      iconComponent() {
        const normalizedVariant = (this.variant || 'primary').toLowerCase();
        const normalizedIcon = (this.icon || '').toLowerCase();

        if (normalizedIcon === 'alertoutline' || normalizedIcon === 'alert-outline') return IconAlertOutline;
        if (normalizedIcon === 'info') return IconInfo;
        if (normalizedIcon === 'danger') return IconError;
        if (normalizedIcon === 'alert') return IconAlert;
        if (normalizedIcon === 'success') return IconSuccess;

        if (normalizedVariant === 'success') return IconSuccess;
        if (normalizedVariant === 'danger') return IconError;
        if (normalizedVariant === 'alert') return IconAlert;
        if (normalizedVariant === 'info') return IconInfo;
        return IconInfo;
      }
    }
  };
</script>

<style></style>

<style lang="scss" scoped>
  .toastification {
    width: 380px;
    padding: 16px;
    margin: 0 !important;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    box-shadow: 0 18px 38px rgba(0, 0, 0, 0.28);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    color: #fff;

    &.success {
      background: linear-gradient(145deg, rgba(55, 139, 74, 0.98), rgba(35, 123, 62, 0.94));
      border-left: 4px solid #7ee081;
    }
    &.danger {
      background: linear-gradient(145deg, rgba(183, 54, 50, 0.98), rgba(145, 32, 29, 0.94));
      border-left: 4px solid #ff8a80;
    }
    &.alert {
      background: linear-gradient(145deg, rgba(211, 130, 0, 0.98), rgba(173, 103, 0, 0.94));
      border-left: 4px solid #ffcc80;
    }
    &.info {
      background: linear-gradient(145deg, rgba(33, 150, 243, 0.98), rgba(21, 101, 192, 0.94));
      border-left: 4px solid #90caf9;
    }
    &.primary {
      background: linear-gradient(145deg, rgba(87, 89, 89, 0.97), rgba(50, 52, 52, 0.95));
      border-left: 4px solid #9ea0a0;
    }
    .toast__container {
      display: flex;
      align-items: flex-start;
      gap: 12px;

      .col-icon {
        margin-top: 2px;
        .toast__icon {
          width: 20px;
          height: 20px;
          flex: 0 0 20px;
          color: #fff;
        }
      }

      .toast__close-button-c {
        cursor: pointer;
        opacity: 0.75;
        transition: opacity 0.2s ease;
        line-height: 0;
        svg {
          width: 19px;
          height: 19px;
          fill: #fff;
        }

        &:hover,
        &:focus-within {
          opacity: 1;
        }

        &:focus-visible {
          outline: 1px solid rgba(255, 255, 255, 0.7);
          outline-offset: 2px;
        }

      }

      .toast__content {
        width: 100%;
        .toast__text-area {
          margin-left: 5px;
          display: flex;
          flex-direction: column;

          .toast__title {
            font-size: 18px;
            font-style: normal;
            font-weight: 600;
            line-height: 24px;
            color: #fff;
          }

          .toast__text {
            color: rgba(255, 255, 255, 0.95);
            font-weight: 400;
            font-size: 13px;
            line-height: 20px;
          }
        }
      }

      .toast__close-button-c {
        margin-left: 16px;
      }
    }
  }

  @media (max-width: 485px) {
    .toastification {
      width: 288px !important;
    }
  }
</style>
